document.addEventListener('DOMContentLoaded', function () {
  var mobileMq = window.matchMedia('(max-width: 749px)');
  var sliders = document.querySelectorAll('.js-sugerencias-kit-slider');

  if (!sliders.length) return;

  function initSlider(el) {
    if (el.dataset.flickityReady === 'true') return;
    if (typeof Flickity === 'undefined') return;

    var flkty = new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      groupCells: false,
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      wrapAround: false,
      adaptiveHeight: false,
      imagesLoaded: true
    });

    el._flickityInstance = flkty;
    el.dataset.flickityReady = 'true';
  }

  function destroySlider(el) {
    if (el._flickityInstance) {
      el._flickityInstance.destroy();
      el._flickityInstance = null;
    }

    el.dataset.flickityReady = 'false';
  }

  function handleSliderState() {
    sliders.forEach(function (el) {
      if (mobileMq.matches) {
        initSlider(el);
      } else {
        destroySlider(el);
      }
    });
  }

  handleSliderState();

  if (typeof mobileMq.addEventListener === 'function') {
    mobileMq.addEventListener('change', handleSliderState);
  } else if (typeof mobileMq.addListener === 'function') {
    mobileMq.addListener(handleSliderState);
  }
});